import {
  Box,
  Dialog as MUIDialog,
  FormControlLabel,
  ListItem as MUIListItem,
  styled,
  Typography,
} from '@mui/material';
import palette from 'styles/theme/palette';

export const StyledDialog = styled(MUIDialog)({
  '.MuiDialog-container > .MuiPaper-root': {
    maxWidth: '560px',
  },
});

export const Section = styled(Box)({
  '&:not(:first-of-type)': {
    marginTop: '24px',
  },
});

export const SectionHeader = styled(Typography)({
  display: 'block',
  marginBottom: '6px',
  fontWeight: 600,
});

export const RequiredAsterisk = styled('span')({
  color: palette.red['500'],
  marginLeft: '2px',
});

export const MethodOption = styled(FormControlLabel)({
  alignItems: 'flex-start',
  margin: 0,
  padding: '8px 0',

  '.MuiRadio-root': {
    padding: 0,
    marginRight: '10px',
  },
});

export const MethodLabel = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
});

export const MethodTitle = styled(Typography)({
  display: 'block',
  color: palette.text.primary,
  fontWeight: 500,
});

export const MethodHint = styled(Typography)({
  display: 'block',
  color: palette.text.secondary,
});

export const ScorecardsList = styled(Box)({
  maxHeight: '280px',
  overflowY: 'auto',
});

export const ListItem = styled(MUIListItem, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ isSelected }) => ({
  background: palette.grey['100'],
  padding: '6px 16px',
  borderRadius: '4px',
  marginBottom: '10px',
  border: `1px solid ${isSelected ? palette.blue['400'] : 'transparent'}`,

  '&:hover': {
    cursor: 'pointer',
  },

  '.MuiListItemAvatar-root': {
    minWidth: 'unset',
    marginRight: '8px',
  },
  '.MuiListItemText-root': {
    margin: 0,
  },
}));

export const CloneNote = styled(Typography)({
  display: 'block',
  marginBottom: '12px',
  color: palette.text.secondary,
});

export const CloneListText = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
});

export const CloneListTitle = styled(Typography)({
  color: palette.text.primary,
  fontWeight: 500,
});

export const CloneListMeta = styled(Typography)({
  color: palette.text.secondary,
});

export const CloneListMetaRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
});

export const CloneListMetaDivider = styled('span')({
  color: palette.text.secondary,
});
